<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item label="single landing page">
      <el-switch v-model="item.useSameLandingPage" />
    </el-form-item>
    <el-form-item
      label="Landing Page"
      v-if="item.useSameLandingPage"
      :rules="urlRule(item.landing_page)"
      label-width="120px"
    >
      <el-input v-model="item.landing_page"></el-input>
    </el-form-item>
      <el-form-item label="effect type" label-width="137px">
      <el-select v-model="item.effectType">
        <el-option
          v-for="option in typeOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <form-item-group
      title="Images"
      :min="imgMin"
      :max="imgMax"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.ROTATINGFERRISWHELL.ITEM"
      v-model="item.images"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image Front"
          :prop="`images.${index}.urlFront`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.images[index].urlFront"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Image Back"
          :prop="`images.${index}.urlBack`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.images[index].urlBack"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          v-if="!item.useSameLandingPage"
          :prop="`images.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.images[index].landing_page"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

const { ROTATINGFERRISWHELL } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        images: [...Array(ROTATINGFERRISWHELL.MIN_NUM)].map(() =>
          _.cloneDeep(ROTATINGFERRISWHELL.ITEM)
        ),
        useSameLandingPage: true,
        landing_page: "",
        effectType: 0,
        cacheImages: [],
      },
      limited_size: {
        image: {
          width: {
            max: 750,
            min: 750,
          },
          height: {
            max: 300,
            min: 300,
          },
        },
      },
      typeOptions: [
        { label: "TRADITION",value: CONSTANT.ROTATINGFERRISWHELL_TYPE.TRADITION },
        { label: "STOP", value: CONSTANT.ROTATINGFERRISWHELL_TYPE.STOP },
      ],
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  computed: {
    imgMin() {
      return (this.item.effectType == CONSTANT.ROTATINGFERRISWHELL_TYPE.STOP) ? CONSTANT.CREATIVE_DEFAULT_VALUE.ROTATINGFERRISWHELL_STOP.MIN_NUM: CONSTANT.CREATIVE_DEFAULT_VALUE.ROTATINGFERRISWHELL.MIN_NUM;
    },
    imgMax() {
      return (this.item.effectType ==CONSTANT.ROTATINGFERRISWHELL_TYPE.STOP) ? CONSTANT.CREATIVE_DEFAULT_VALUE.ROTATINGFERRISWHELL_STOP.MAX_NUM : CONSTANT.CREATIVE_DEFAULT_VALUE.ROTATINGFERRISWHELL.MAX_NUM;
    }
  },
  watch: {
    'item.effectType'(newVal, oldVal) {
      if (newVal == CONSTANT.ROTATINGFERRISWHELL_TYPE.STOP) {
        this.item.cacheImages = this.item.images.splice(1, this.item.images.length - 1);
      } else {
        if (this.item.cacheImages.length > 0) {
          this.item.images = [...this.item.images, ...this.item.cacheImages];
          this.item.cacheImages = [];
        }
      }
    },
  },
  methods: {
    setData(row) {
      this.item.images = _.map(row.images, (image) => {
        return {
          urlFront: decodeURI(image.urlFront),
          urlBack: decodeURI(image.urlBack),
          landing_page: decodeURI(image.landing_page),
        };
      });
      this.item.useSameLandingPage = row.useSameLandingPage;
      this.item.effectType = row.effectType;
      this.item.landing_page = decodeURI(row.landing_page);
    },
    async getData(setObj) {
      setObj.images = _.map(this.item.images, (image) => {
        return {
          urlFront: decodeURI(image.urlFront),
          urlBack: decodeURI(image.urlBack),
          landing_page: (this.item.useSameLandingPage) ? this.item.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)) : image.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      setObj.useSameLandingPage = this.item.useSameLandingPage;
      setObj.effectType = this.item.effectType;
      setObj.landing_page = (this.item.useSameLandingPage) ? this.item.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)) : this.item.images[0].landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      return setObj;
    },
  },
};
</script>

<style></style>
